const AUTH_IDENTIFIER_ENDPOINT = "/api/auth-identifier";

async function parseJsonResponse(response, fallbackMessage) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok === false) {
    const error = new Error(data.message || fallbackMessage);
    error.status = response.status;
    error.payload = data;
    throw error;
  }
  return data;
}

export async function resolveLoginIdentifier(identifier) {
  const response = await fetch(AUTH_IDENTIFIER_ENDPOINT, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ identifier }),
  });
  return parseJsonResponse(response, "Giriş bilgisi doğrulanamadı.");
}
